import React, { useState, useEffect, useMemo } from 'react';
import { Container, Row, Col, Form, Button, Table, Modal, Card, InputGroup } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchJb_list, removeJb } from '../../store'; // Redux 액션들 임포트
import config from '../../config';
import axios from 'axios';

function JBSetting() {

  // ... existing code ...
  const [MaxEffCurrentCheck, setMaxEffCurrentCheck] = useState('50.0');
  const [MinEffCurrentCheck, setMinEffCurrentCheck] = useState('10.0');
  const [showBnmAddModal, setShowBnmAddModal] = useState(false);
  const [showBnmChildListModal, setShowBnmChildListModal] = useState(false);
  const [bnmLcItems, setBnmLcItems] = useState([{ name: 'BNM-LC-1', id: '', address: '', commPort: 'RS485-CH1', ip: '', port: '', protocol: 'Bnm_lc' }]);
  const [bnmCoItems, setBnmCoItems] = useState([{ name: 'BNM-CO-1', id: '', address: '', commPort: 'RS485-CH1', ip: '', port: '', protocol: 'Bnm_co' }]);

  const handleSaveJbChMinMaxEff = () => {
    axios.post(`${config.backendUrl}/api/update-current-MaxMinEff`, {
      MaxEffCurrentCheck: MaxEffCurrentCheck,
      MinEffCurrentCheck: MinEffCurrentCheck,
    })
      .then(response => {
        alert('접속함 채널 효율 설정값이 저장되었습니다.');
      })
      .catch(error => {
        console.error('접속함 채널 효율 설정값 저장 중 오류:', error);
        alert('저장 실패');
      });
  };



  const dispatch = useDispatch();

  // Redux store에서 JB 목록 및 설정값 불러오기
  const Jb_list = useSelector((state) => state.Jb_list || []);
  const JbMrtData = useSelector((state) => state.JbMrtData || {});
  const settingList = useSelector((state) => state.settingList || {});

  useEffect(() => {
    if (settingList.Etc_Setting) {
      setMinEffCurrentCheck(settingList.Etc_Setting.MinEffCurrentCheck);
      setMaxEffCurrentCheck(settingList.Etc_Setting.MaxEffCurrentCheck);
    }
  }, [settingList.Etc_Setting]);
  
  const [inputCommPort, setCommPort] = useState('RS485-CH1');
  const [inputId, setInputId] = useState('1');
  const [inputName, setInputName] = useState('접속함1');
  const [inputProtocol, setInputProtocol] = useState('엠알티-표준');
  const [inputIP, setInputIP] = useState('192.168.105.101');
  const [inputPort, setInputPort] = useState('502');
  const [inputPairSeq, setInputPairSeq] = useState('');

  // 기본값 설정 (채널 이름과 사용 여부)
  const defaultChannelNames = 'CH1,CH2,CH3,CH4,CH5,CH6,CH7,CH8,CH9,CH10,CH11,CH12,CH13,CH14,CH15,CH16,CH17,CH18,CH19,CH20,CH21,CH22,,,,,,,,,,'.split(',');
  const defaultCheckedChannels = '1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0,0,0'.split(',').map(Number);

  const [channelNames, setChannelNames] = useState([...defaultChannelNames]);
  const [checkedChannels, setCheckedChannels] = useState([...defaultCheckedChannels]);

  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const { jb_protocolList = [] } = settingList;  // Redux에서 프로토콜 리스트 가져오기
  const filteredJbProtocolList = useMemo(() => {
    return (jb_protocolList || []).filter((p) => {
      const v = String(p || '').toLowerCase();
      return !/^bnm[-_](lc|co)$/.test(v);
    });
  }, [jb_protocolList]);

  // JB 리스트 불러오기
  useEffect(() => {
    dispatch(fetchJb_list());
  }, [dispatch]);

  // '지투 파워' 프로토콜 선택 여부를 판별 (지투파워/지투 파워/G2 등 폭넓게 허용)
  const isG2Protocol = useMemo(() => {
    const v = (inputProtocol || '').toString();
    return /(지투\s*파워|지투파워|g2)/i.test(v);
  }, [inputProtocol]);

  // 지투 파워가 아니면 페어 선택 초기화
  useEffect(() => {
    if (!isG2Protocol) setInputPairSeq('');
  }, [isG2Protocol]);
  // 엠알티-표준 장비 목록(페어 후보) 생성: 같은 통신포트를 우선 배치
  const mrtPairOptions = useMemo(() => {
    const seqArr = Jb_list.seq || [];
    const protocolArr = Jb_list.jb_protocol || [];
    const nameArr = Jb_list.jb_name || [];
    const addrArr = Jb_list.jb_address || [];
    const portArr = Jb_list.jb_commPort || [];
    const items = seqArr.map((seq, i) => ({
      seq,
      protocol: protocolArr[i],
      name: nameArr[i],
      address: addrArr[i],
      commPort: portArr[i]
    })).filter(it => it.protocol === '엠알티-표준');
    // 같은 포트를 우선 정렬
    items.sort((a, b) => {
      const aSame = a.commPort === inputCommPort ? 0 : 1;
      const bSame = b.commPort === inputCommPort ? 0 : 1;
      if (aSame !== bSame) return aSame - bSame;
      // 보조 정렬: 포트, 주소, 이름
      if (a.commPort !== b.commPort) return (a.commPort || '').localeCompare(b.commPort || '');
      if ((a.address || 0) !== (b.address || 0)) return (a.address || 0) - (b.address || 0);
      return (a.name || '').localeCompare(b.name || '');
    });
    return items;
  }, [Jb_list, inputCommPort]);

  // JB 추가/수정
  const jbAddClick = async () => {
    // 비엔엠 선택 시 추가 설정 모달 우선 표시
    if (inputProtocol === '비엔엠') {
      // 초기값을 부모 설정으로 동기화
      setBnmLcItems([{ name: 'BNM-LC-1', id: '', address: '', commPort: inputCommPort, ip: inputCommPort === 'ETHERNET' ? inputIP : '', port: inputCommPort === 'ETHERNET' ? inputPort : '', protocol: 'Bnm_lc' }]);
      setBnmCoItems([{ name: 'BNM-CO-1', id: '', address: '', commPort: inputCommPort, ip: inputCommPort === 'ETHERNET' ? inputIP : '', port: inputCommPort === 'ETHERNET' ? inputPort : '', protocol: 'Bnm_co' }]);
      setShowBnmAddModal(true);
      return;
    }
    // 다음 ID, IP, 이름 생성
    const nextId = (parseInt(inputId) + 1).toString();
    const ipParts = inputIP.split('.');
    // const nextIP = `${ipParts[0]}.${ipParts[1]}.${ipParts[2]}.${parseInt(ipParts[3]) + 1}`;
    const nextName = `접속함${nextId}`;

    // 기본값 설정
    const defaultChannelNames = 'CH1,CH2,CH3,CH4,CH5,CH6,CH7,CH8,CH9,CH10,CH11,CH12,CH13,CH14,CH15,CH16,CH17,CH18,CH19,CH20,CH21,CH22,,,,,,,,,,';
    const defaultChannelUsage = '1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,0,0,0,0,0,0,0';

    const newJunctionBox = {
      id: inputId,
      name: inputName,
      protocol: inputProtocol,
      commPort: inputCommPort,
      ip: inputCommPort === 'ETHERNET' ? inputIP : '', // 이더넷일 때만 IP 설정
      port: inputCommPort === 'ETHERNET' ? inputPort : '', // 이더넷일 때만 포트 설정
      jb_pv_ch_name: defaultChannelNames, // 기본 채널 이름 설정
      jb_pv_ch_use: defaultChannelUsage,  // 기본 채널 사용 여부 설정
      address: parseInt(inputId, 10) || 0, // 주소 값
      pair_device: null,
    };
    console.log('[JB ADD] payload:', newJunctionBox);

    try {
      const resolveSeq = async (commPort, address, protocol) => {
        try {
          const listResp = await axios.get(`${config.backendUrl}/api/jbs`);
          const list = Array.isArray(listResp.data) ? listResp.data : [];
          const found = list.find(
            (it) => it.jb_commPort === commPort && Number(it.jb_address) === Number(address) && it.jb_protocol === protocol
          );
          return found ? found.seq : null;
        } catch (e) {
          console.error('[JB ADD] resolveSeq failed:', e);
          return null;
        }
      };
      // 장비 등록
      const resp = await axios.post(`${config.backendUrl}/api/jbs`, newJunctionBox);
      console.log('[JB ADD] response status:', resp.status);
      let createdSeq = resp?.data?.seq;
      if (!createdSeq) {
        createdSeq = await resolveSeq(inputCommPort, inputId, inputProtocol);
      }
      console.log('[JB ADD] created seq:', createdSeq);

      // 성공 후 다음 입력값 준비 및 목록 갱신
      dispatch(fetchJb_list());
      const inc = 1;
      const nextIdNumber = (parseInt(inputId, 10) || 0) + inc;
      setInputId(String(nextIdNumber));
      setInputName(`접속함${nextIdNumber}`);
      setInputIP(inputIP);
      setInputPort('502');
    } catch (error) {
      console.error('추가 중 오류 발생:', error);
    }

    setShowModal(false);
  };

  const addBnmRow = (type) => {
    if (type === 'lc') {
      setBnmLcItems((prev) => [...prev, { name: `BNM-LC-${prev.length + 1}`, id: '', address: '', commPort: inputCommPort, ip: inputCommPort === 'ETHERNET' ? inputIP : '', port: inputCommPort === 'ETHERNET' ? inputPort : '', protocol: 'Bnm_lc' }]);
    } else {
      setBnmCoItems((prev) => [...prev, { name: `BNM-CO-${prev.length + 1}`, id: '', address: '', commPort: inputCommPort, ip: inputCommPort === 'ETHERNET' ? inputIP : '', port: inputCommPort === 'ETHERNET' ? inputPort : '', protocol: 'Bnm_co' }]);
    }
  };

  const removeBnmRow = (type, idx) => {
    if (type === 'lc') {
      setBnmLcItems((prev) => prev.filter((_, i) => i !== idx));
    } else {
      setBnmCoItems((prev) => prev.filter((_, i) => i !== idx));
    }
  };

  const updateBnmRow = (type, idx, field, value) => {
    if (type === 'lc') {
      setBnmLcItems((prev) => prev.map((it, i) => (i === idx ? { ...it, [field]: value } : it)));
    } else {
      setBnmCoItems((prev) => prev.map((it, i) => (i === idx ? { ...it, [field]: value } : it)));
    }
  };

  const handleConfirmBnmAdd = async () => {
    try {
      // 1) 비엔엠 부모 생성
      const parentPayload = {
        id: inputId,
        name: inputName,
        protocol: '비엔엠',
        commPort: inputCommPort,
        ip: inputCommPort === 'ETHERNET' ? inputIP : '',
        port: inputCommPort === 'ETHERNET' ? inputPort : '',
        jb_pv_ch_name: defaultChannelNames.join(','),
        jb_pv_ch_use: defaultCheckedChannels.map(v => (v ? '1' : '0')).join(','),
        address: parseInt(inputId, 10) || 0,
        pair_device: null,
      };
      const parentResp = await axios.post(`${config.backendUrl}/api/jbs`, parentPayload);
      let parentSeq = parentResp?.data?.seq;
      if (!parentSeq) {
        // fallback resolve: 이름 우선 매칭, 없으면 동일 속성 중 seq 최대값(최신 생성)
        try {
          const listResp = await axios.get(`${config.backendUrl}/api/jbs`);
          const list = Array.isArray(listResp.data) ? listResp.data : [];
          const candidates = list.filter(
            (it) =>
              it.jb_protocol === parentPayload.protocol &&
              it.jb_commPort === parentPayload.commPort &&
              Number(it.jb_address) === Number(parentPayload.address)
          );
          // 1) 이름 완전일치 우선
          const byName = candidates.find((it) => it.jb_name === parentPayload.name);
          if (byName) {
            parentSeq = byName.seq;
          } else if (candidates.length) {
            // 2) 최신 생성(가장 큰 seq)
            candidates.sort((a, b) => (Number(b.seq || 0) - Number(a.seq || 0)));
            parentSeq = candidates[0].seq;
          } else {
            parentSeq = null;
          }
        } catch {}
      }
      if (!parentSeq) throw new Error('비엔엠 부모 seq 확인 실패');

      // 2) LC/CO 자식들 생성 + pair_device = parentSeq
      const makeChild = async (row) => {
        const addrNum = row.id ? parseInt(row.id, 10) : (row.address ? parseInt(row.address, 10) : NaN);
        const child = {
          id: isNaN(addrNum) ? '' : String(addrNum),
          name: row.name,
          protocol: row.protocol,
          commPort: row.commPort,
          ip: row.commPort === 'ETHERNET' ? (row.ip || '') : '',
          port: row.commPort === 'ETHERNET' ? (row.port || '') : '',
          jb_pv_ch_name: defaultChannelNames.join(','),
          jb_pv_ch_use: defaultCheckedChannels.map(v => (v ? '1' : '0')).join(','),
          address: isNaN(addrNum) ? 0 : addrNum,
          pair_device: parentSeq,
        };
        const resp = await axios.post(`${config.backendUrl}/api/jbs`, child);
        let childSeq = resp?.data?.seq;
        if (!childSeq) {
          try {
            const listResp = await axios.get(`${config.backendUrl}/api/jbs`);
            const list = Array.isArray(listResp.data) ? listResp.data : [];
            const candidates = list.filter(
              (it) =>
                it.jb_protocol === child.protocol &&
                it.jb_commPort === child.commPort &&
                Number(it.jb_address) === Number(child.address) &&
                it.pair_device === parentSeq
            );
            const byName = candidates.find((it) => it.jb_name === child.name);
            if (byName) childSeq = byName.seq;
            else if (candidates.length) {
              candidates.sort((a, b) => (Number(b.seq || 0) - Number(a.seq || 0)));
              childSeq = candidates[0].seq;
            }
          } catch {}
        }
        return childSeq;
      };

      // 주소가 비었으면 부모ID 다음부터 자동 할당
      let nextAddr = (parseInt(inputId, 10) || 0) + 1;
      for (const it of bnmLcItems) {
        if (!it.id && !it.address) it.id = String(nextAddr++);
        await makeChild(it);
      }
      for (const it of bnmCoItems) {
        if (!it.id && !it.address) it.id = String(nextAddr++);
        await makeChild(it);
      }

      // 목록 갱신 및 다음 기본값 준비
      dispatch(fetchJb_list());
      const nextIdNumber = nextAddr; // 마지막 사용 주소 다음
      setInputId(String(nextIdNumber));
      setInputName(`접속함${nextIdNumber}`);
      setShowBnmAddModal(false);
      // 초기화
      setBnmLcItems([{ name: 'BNM-LC-1', id: '', address: '', commPort: 'RS485-CH1', ip: '', port: '', protocol: 'Bnm_lc' }]);
      setBnmCoItems([{ name: 'BNM-CO-1', id: '', address: '', commPort: 'RS485-CH1', ip: '', port: '', protocol: 'Bnm_co' }]);
    } catch (e) {
      alert('비엔엠 추가 중 오류가 발생했습니다. 콘솔을 확인하세요.');
      console.error(e);
    }
  };

  // 수정 클릭 시 데이터 세팅
  const handleEditClick = (index) => {
    if (
      Jb_list.jb_commPort[index] !== undefined &&
      Jb_list.jb_address[index] !== undefined &&
      Jb_list.jb_name[index] !== undefined
    ) {
      // 데이터를 안전하게 설정
      setEditIndex(index);
      setCommPort(Jb_list.jb_commPort[index] || ''); // 기본값 설정
      setInputId(Jb_list.jb_address[index] || '');
      setInputName(Jb_list.jb_name[index] || '');
      setInputProtocol(Jb_list.jb_protocol[index] || '');
      setInputIP(Jb_list.jb_ethernetIp[index] || '');
      setInputPort(Jb_list.jb_ethernetPort[index] || '');
      setInputPairSeq(''); // 서버 스키마 연동 전이므로 편집 시 기본값 공백

      // 채널 이름과 사용 여부를 배열로 변환
      const channelNamesData = Jb_list.jb_pv_ch_name[index]?.split(',') || [...defaultChannelNames];
      const checkedChannelsData = Jb_list.jb_pv_ch_use[index]?.split(',').map(Number) || [...defaultCheckedChannels];

      setChannelNames(channelNamesData);
      setCheckedChannels(checkedChannelsData);

      setShowModal(true);
    } else {
      console.error('Invalid data or index:', index);
    }
  };

  // 채널 사용 여부 체크박스 처리
  const handleChannelCheck = (index) => {
    const newCheckedChannels = [...checkedChannels];
    newCheckedChannels[index] = newCheckedChannels[index] === 1 ? 0 : 1; // 1과 0으로 상태 반전
    setCheckedChannels(newCheckedChannels);

    // 업데이트된 체크박스 상태 배열 확인
    // console.log('Updated checkedChannels:', newCheckedChannels);
  };



  const handleSaveClick = async () => {
    // 체크된 채널 상태 배열이 유효한지 확인
    const adjustedCheckedChannels = checkedChannels.length ? checkedChannels : Array(channelNames.length).fill(0);

    // adjustedCheckedChannels 배열을 1과 0으로 변환하여 쉼표로 구분된 문자열 생성
    const jb_pv_ch_use = adjustedCheckedChannels
      .map(checked => (checked ? '1' : '0')) // true는 '1', false는 '0'으로 변환
      .join(','); // 쉼표로 구분된 문자열로 변환

    // jb_pv_ch_name을 쉼표로 구분된 문자열로 변환
    const jb_pv_ch_name = channelNames.join(',');

    // 서버로 보낼 최종 데이터
    const updatedJunctionBox = {
      id: inputId,
      name: inputName,
      protocol: inputProtocol,
      ip: inputCommPort === 'ETHERNET' ? inputIP : '',
      port: inputCommPort === 'ETHERNET' ? inputPort : '',
      commPort: inputCommPort,
      jb_pv_ch_name,  // 쉼표로 구분된 채널 이름
      jb_pv_ch_use,   // 쉼표로 구분된 체크박스 상태
      address: parseInt(inputId, 10) || 0,  // address 필드
      pair_device: null,
    };



    const seq = Jb_list.seq[editIndex]; // 수정할 접속함의 seq 값 가져오기

    try {
      // 서버에 업데이트 요청
      const response = await axios.put(`${config.backendUrl}/api/update_jb/${seq}`, updatedJunctionBox);
      if (response.status === 200) {
        // console.log('Junction Box updated successfully:', response.data);
        dispatch(fetchJb_list());  // 변경 사항 반영을 위해 리스트를 다시 불러옴
      } else {
        console.error('Failed to update Junction Box:', response);
      }
    } catch (error) {
      console.error('An error occurred while updating Junction Box:', error);
    }

    // 모달 닫기
    setShowModal(false);
  };





  // 삭제 클릭 시 (비엔엠 부모 삭제 시 자식도 함께 삭제)
  const handleDeleteClick = async (index) => {
    const jbName = Jb_list.jb_name[index];
    const seqArr = Jb_list.seq || [];
    const protoArr = Jb_list.jb_protocol || [];
    const pairArr = (Jb_list.pair_device || Jb_list.pair_seq) || [];
    const parentSeq = seqArr[index];
    const isBnmParent = protoArr[index] === '비엔엠';

    // 자식 seq 수집 (Bnm_lc / Bnm_co, pair_device === parentSeq)
    const childSeqs = isBnmParent
      ? seqArr.filter((seq, i) => (protoArr[i] === 'Bnm_lc' || protoArr[i] === 'Bnm_co') && pairArr[i] === parentSeq)
      : [];

    let message = `${jbName}를 정말로 삭제하시겠습니까?`;
    if (isBnmParent && childSeqs.length > 0) {
      message = `${jbName}를 삭제하면 연결된 BNM 장비 ${childSeqs.length}대도 함께 삭제됩니다. 진행하시겠습니까?`;
    }
    const confirmDelete = window.confirm(message);
    if (!confirmDelete) return;

    try {
      if (isBnmParent) {
        // 자식 먼저 삭제
        await Promise.all(
          childSeqs.map((cseq) =>
            axios.delete(`${config.backendUrl}/api/jbs/${cseq}`).catch((e) => {
              console.error('연결된 장비 삭제 실패:', e);
            })
          )
        );
        // 부모 삭제
        await axios.delete(`${config.backendUrl}/api/jbs/${parentSeq}`);
        // 목록 새로고침
        dispatch(fetchJb_list());
        window.alert(`${jbName} 및 연결된 장비가가 삭제되었습니다.`);
      } else {
        await axios.delete(`${config.backendUrl}/api/jbs/${parentSeq}`);
        dispatch(removeJb(index));
        window.alert(`${jbName} : 삭제 완료`);
      }
    } catch (error) {
      console.error('삭제 중 오류 발생:', error);
      window.alert(`${jbName} : 삭제 중 오류가 발생했습니다.`);
    }
  };

  return (
    <Container className="mt-5">
      <Row className="align-items-center justify-content-center mb-3">
        <Col md="2">
          <Form.Label className="text-center w-100">통신 포트</Form.Label>
          <Form.Control
            as="select"
            value={inputCommPort}
            onChange={(e) => setCommPort(e.target.value)}
            className="text-center"
          >
            {settingList.commPortList.map((port, index) => (
              <option key={index} value={port}>
                {port}
              </option>
            ))}
          </Form.Control>
        </Col>
        {inputCommPort === 'ETHERNET' && (
          <>
            <Col md="2">
              <Form.Label className="text-center w-100">IP 주소</Form.Label>
              <Form.Control
                type="text"
                value={inputIP}
                onChange={(e) => setInputIP(e.target.value)}
                className="text-center"
                placeholder="192.168.105.101"
              />
            </Col>
            <Col md="1">
              <Form.Label className="text-center w-100">포트</Form.Label>
              <Form.Control
                type="text"
                value={inputPort}
                onChange={(e) => setInputPort(e.target.value)}
                className="text-center"
                placeholder="502"
              />
            </Col>
          </>
        )}
        <Col md="1">
          <Form.Label className="text-center w-100">장비 ID</Form.Label>
          <Form.Control
            type="text"
            value={inputId}
            onChange={(e) => setInputId(e.target.value)}
            className="text-center"
          />
        </Col>
        <Col md="2">
          <Form.Label className="text-center w-100">접속함 이름</Form.Label>
          <Form.Control
            type="text"
            value={inputName}
            onChange={(e) => setInputName(e.target.value)}
            className="text-center"
          />
        </Col>
        <Col md="2">
          <Form.Label className="text-center w-100">프로토콜 선택</Form.Label>
          <Form.Control
            as="select"
            value={inputProtocol}
            onChange={(e) => setInputProtocol(e.target.value)}
            className="text-center"
          >
            {filteredJbProtocolList.map((protocol, index) => (
              <option key={index} value={protocol}>
                {protocol}
              </option>
            ))}
          </Form.Control>
        </Col>
        <Col md="2" className="text-center">
          <Button variant="info" onClick={jbAddClick} className="mt-4 w-100">
            접속함 추가
          </Button>
        </Col>
        <Col md="2" className="text-center">
          <Button
            variant="secondary"
            size="sm"
            onClick={() => setShowBnmChildListModal(true)}
            className="mt-4 w-100 shadow-sm btn-secondary-soft"
            title="BNM 연결된 장비 관리"
          >BNM 연결된 장비 관리
          </Button>
        </Col>
      </Row>

      <Row className="mt-4 mb-4 align-items-center justify-content-center">
        <Col md={12}>
          <Form className="d-flex align-items-center justify-content-center">
            <span className="me-3">모든 채널중 전류 최대값이</span>
            <Form.Control
              type="text"
              value={MaxEffCurrentCheck}
              onChange={(e) => setMaxEffCurrentCheck(e.target.value)}
              className="text-center"
              style={{ width: '150px' }}
            />
            <span className="me-3">&nbsp;A 이상일때</span>
            <Form.Control
              type="text"
              value={MinEffCurrentCheck}
              onChange={(e) => setMinEffCurrentCheck(e.target.value)}
              className="text-center"
              style={{ width: '150px' }}
            />
            <span className="me-3">&nbsp;A 이하이면 효율경보 발생</span>
            <Button
              variant="primary"
              onClick={handleSaveJbChMinMaxEff}
              className="ms-3"
            >
              저장
            </Button>
          </Form>
        </Col>
      </Row>


      {/* 테이블 렌더링 */}
      {Array.from(new Set(Jb_list.jb_commPort)).map((port) => (
        <div key={port}>
          <Table striped bordered hover className="text-center">
            <thead>
              <tr>
                <th>#</th>
                <th>{port}</th>
                <th>장비 ID</th>
                <th>접속함 이름</th>
                <th>프로토콜</th>
                {port === 'ETHERNET' && (
                  <>
                    <th>IP 주소</th>
                    <th>포트</th>
                  </>
                )}
                <th>송신</th>
                <th>수신</th>
                <th>수정</th>
                <th>삭제</th>
              </tr>
            </thead>
            <tbody>
              {Jb_list.seq.map((_, index) => {
                // 비엔엠 자식(Bnm_lc/Bnm_co)은 표에서 숨김
                const proto = Jb_list.jb_protocol[index];
                if (proto === 'Bnm_lc' || proto === 'Bnm_co') return null;
                if (Jb_list.jb_commPort[index] === port) {
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{Jb_list.jb_commPort[index]}</td>
                      <td>{Jb_list.jb_address[index]}</td>
                      <td>{Jb_list.jb_name[index]}</td>
                      <td>{Jb_list.jb_protocol[index]}</td>
                      {port === 'ETHERNET' && (
                        <>
                          <td>{Jb_list.jb_ethernetIp[index]}</td>
                          <td>{Jb_list.jb_ethernetPort[index]}</td>
                        </>
                      )}
                      <td>{JbMrtData.sendCount[index]}</td> {/* 송신 데이터 표시 */}
                      <td>{JbMrtData.receiveCount[index]}</td> {/* 수신 데이터 표시 */}
                      <td>
                        <Button
                          variant="warning"
                          onClick={() => handleEditClick(index)}
                          style={{ padding: '5px 10px', fontSize: '12px' }}
                        >
                          수정
                        </Button>
                      </td>
                      <td>
                        <Button
                          variant="danger"
                          onClick={() => handleDeleteClick(index)}
                          style={{ padding: '5px 10px', fontSize: '12px' }}
                        >
                          삭제
                        </Button>
                      </td>
                    </tr>
                  );
                }
                return null;
              })}
            </tbody>
          </Table>
        </div>
      ))}

      {/* BNM 자식 관리 모달 */}
      <Modal show={showBnmChildListModal} onHide={() => setShowBnmChildListModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>BNM-LC / BNM-CO 등록 장비</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered hover className="text-center">
            <thead>
              <tr>
                <th>#</th>
                <th>통신 포트</th>
                <th>장비 ID</th>
                <th>접속함 이름</th>
                <th>프로토콜</th>
                <th>부모 seq</th>
                <th>삭제</th>
              </tr>
            </thead>
            <tbody>
              {(Jb_list.seq || []).map((seq, i) => {
                const proto = (Jb_list.jb_protocol || [])[i];
                if (proto !== 'Bnm_lc' && proto !== 'Bnm_co') return null;
                return (
                  <tr key={`child-${seq}-${i}`}>
                    <td>{i + 1}</td>
                    <td>{(Jb_list.jb_commPort || [])[i]}</td>
                    <td>{(Jb_list.jb_address || [])[i]}</td>
                    <td>{(Jb_list.jb_name || [])[i]}</td>
                    <td>{proto}</td>
                    <td>{(Jb_list.pair_device || [])[i] ?? '-'}</td>
                    <td>
                      <Button
                        variant="danger"
                        onClick={() => handleDeleteClick(i)}
                        style={{ padding: '5px 10px', fontSize: '12px' }}
                      >
                        삭제
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowBnmChildListModal(false)}>닫기</Button>
        </Modal.Footer>
      </Modal>

      {/* 수정 모달 */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>접속함 수정</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {/* 왼쪽: 기본 정보 (크기를 줄임) */}
            <Col md={4}> {/* 왼쪽 크기를 md={6}에서 md={4}로 줄임 */}
              <Form>
                <Form.Group>
                  <Form.Label>통신 포트</Form.Label>
                  <Form.Control
                    as="select"
                    value={inputCommPort}
                    onChange={(e) => setCommPort(e.target.value)}
                    className="text-center"
                    style={{ fontSize: '14px' }} // 폰트 크기 조정
                  >
                    {settingList.commPortList.map((port, index) => (
                      <option key={index} value={port}>
                        {port}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
                {inputCommPort === 'ETHERNET' && (
                  <>
                    <Form.Group>
                      <Form.Label>IP 주소</Form.Label>
                      <Form.Control
                        type="text"
                        value={inputIP}
                        onChange={(e) => setInputIP(e.target.value)}
                        className="text-center"
                        placeholder="192.168.105.101"
                        style={{ fontSize: '14px' }} // 폰트 크기 조정
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>포트</Form.Label>
                      <Form.Control
                        type="text"
                        value={inputPort}
                        onChange={(e) => setInputPort(e.target.value)}
                        className="text-center"
                        placeholder="502"
                        style={{ fontSize: '14px' }} // 폰트 크기 조정
                      />
                    </Form.Group>
                  </>
                )}
                <Form.Group>
                  <Form.Label>장비 ID</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputId}
                    onChange={(e) => setInputId(e.target.value)}
                    className="text-center"
                    style={{ fontSize: '14px' }} // 폰트 크기 조정
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>접속함 이름</Form.Label>
                  <Form.Control
                    type="text"
                    value={inputName}
                    onChange={(e) => setInputName(e.target.value)}
                    className="text-center"
                    style={{ fontSize: '14px' }} // 폰트 크기 조정
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>프로토콜 선택</Form.Label>
                  <Form.Control
                    as="select"
                    value={inputProtocol}
                    onChange={(e) => setInputProtocol(e.target.value)}
                    className="text-center"
                    style={{ fontSize: '14px' }} // 폰트 크기 조정
                  >
                    {filteredJbProtocolList.map((protocol, index) => (
                      <option key={index} value={protocol}>
                        {protocol}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
                {/* isG2Protocol && (
                  <Form.Group>
                    <Form.Label>페어 접속함</Form.Label>
                    <Form.Control
                      as="select"
                      value={inputPairSeq}
                      onChange={(e) => setInputPairSeq(e.target.value)}
                      className="text-center"
                      style={{ fontSize: '14px' }}
                    >
                      <option value="">선택 없음</option>
                      <option value="create_new">엠알티-표준 함께 등록</option>
                    </Form.Control>
                  </Form.Group>
                ) */}
              </Form>
            </Col>

            {/* 오른쪽: 채널 이름과 사용 여부 (더 많은 공간 할당) */}
            <Col md={8}>
              {/* 세로 8개씩, 가로 4줄 */}
              <Row>
                {[...Array(4)].map((_, rowIndex) => (
                  <Col key={rowIndex} md={3} style={{ padding: '0 5px', borderRight: '1px solid #dee2e6' }}>
                    {channelNames.slice(rowIndex * 8, (rowIndex + 1) * 8).map((name, index) => (
                      <Row key={index} className="mb-2 align-items-center" style={{ borderBottom: '1px solid #dee2e6', padding: '5px 0' }}>
                        <Col xs={2} className="text-center">
                          {/* 인덱스 번호 표시 (rowIndex * 8 + index + 1) */}
                          {rowIndex * 8 + index + 1}
                        </Col>
                        <Col xs={6}>
                          <Form.Control
                            type="text"
                            value={name}
                            onChange={(e) => {
                              const newChannelNames = [...channelNames];
                              newChannelNames[rowIndex * 8 + index] = e.target.value;
                              setChannelNames(newChannelNames);
                            }}
                            className="text-center"
                            style={{ fontSize: '12px', padding: '4px' }} // 스트링 입력창을 다시 작게 조정
                          />
                        </Col>
                        <Col xs={4} className="text-center">
                          <Form.Check
                            type="checkbox"
                            checked={checkedChannels[rowIndex * 8 + index]}
                            onChange={() => handleChannelCheck(rowIndex * 8 + index)}
                            style={{ transform: 'scale(1.0)' }} // 체크박스 크기 기본값으로 설정
                          />
                        </Col>
                      </Row>
                    ))}
                  </Col>
                ))}
              </Row>
            </Col>

          </Row>

          {/* 비엔엠 자식(LC/CO) 등록 현황 - 비엔엠일 때만 */}
          {inputProtocol === '비엔엠' && editIndex !== null && (
            <div style={{ marginTop: '20px' }}>
              <div style={{ fontWeight: 600, marginBottom: '8px' }}>BNM-LC / BNM-CO 등록 현황</div>
              <Table striped bordered hover className="text-center">
                <thead>
                  <tr>
                    <th>통신 포트</th>
                    <th>장비 ID</th>
                    <th>접속함 이름</th>
                    <th>프로토콜</th>
                    <th>송신</th>
                    <th>수신</th>
                    <th>삭제</th>
                  </tr>
                </thead>
                <tbody>
                  {(Jb_list.seq || []).map((_, i) => {
                    const proto = (Jb_list.jb_protocol || [])[i];
                    if (proto !== 'Bnm_lc' && proto !== 'Bnm_co') return null;
                    const pairArr = (Jb_list.pair_device || Jb_list.pair_seq) || [];
                    const parentSeq = (Jb_list.seq || [])[editIndex];
                    if (pairArr[i] !== parentSeq) return null;
                    return (
                      <tr key={`bnm-child-${i}`}>
                        <td>{(Jb_list.jb_commPort || [])[i]}</td>
                        <td>{(Jb_list.jb_address || [])[i]}</td>
                        <td>{(Jb_list.jb_name || [])[i]}</td>
                        <td>{proto}</td>
                        <td>{(JbMrtData.sendCount || [])[i] ?? '-'}</td>
                        <td>{(JbMrtData.receiveCount || [])[i] ?? '-'}</td>
                        <td>
                          <Button
                            variant="danger"
                            onClick={() => handleDeleteClick(i)}
                            style={{ padding: '5px 10px', fontSize: '12px' }}
                          >
                            삭제
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            취소
          </Button>
          <Button variant="primary" onClick={handleSaveClick}>
            저장
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 비엔엠 추가 설정 모달 */}
      <Modal show={showBnmAddModal} onHide={() => setShowBnmAddModal(false)} size="xl" scrollable>
        <Modal.Header closeButton>
          <Modal.Title>비엔엠 접속함</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginBottom: '10px', fontWeight: 600 }}>비엔엠 접속함 추가설정</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '16px' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                <div style={{ fontWeight: 600 }}>LC 추가 목록</div>
                <Button size="sm" variant="secondary" onClick={() => addBnmRow('lc')}>행 추가</Button>
              </div>
              <Table striped bordered size="sm">
                <thead>
                  <tr>
                    <th>통신포트</th>
                    <th>IP</th>
                    <th>포트</th>
                    <th>장비ID</th>
                    <th>접속함 이름</th>
                    <th>프로토콜</th>
                    <th>삭제</th>
                  </tr>
                </thead>
                <tbody>
                  {bnmLcItems.map((it, idx) => (
                    <tr key={`lc-${idx}`}>
                      <td>
                        <Form.Select value={it.commPort} onChange={(e) => updateBnmRow('lc', idx, 'commPort', e.target.value)}>
                          {(settingList.commPortList || []).map((p) => (
                            <option key={p} value={p}>{p}</option>
                          ))}
                        </Form.Select>
                      </td>
                      <td>
                        {it.commPort === 'ETHERNET' && (
                          <Form.Control type="text" value={it.ip} onChange={(e) => updateBnmRow('lc', idx, 'ip', e.target.value)} className="text-center" placeholder="192.168.x.x" />
                        )}
                      </td>
                      <td>
                        {it.commPort === 'ETHERNET' && (
                          <Form.Control type="text" value={it.port} onChange={(e) => updateBnmRow('lc', idx, 'port', e.target.value)} className="text-center" placeholder="502" />
                        )}
                      </td>
                      <td>
                        <Form.Control type="text" value={it.id} onChange={(e) => updateBnmRow('lc', idx, 'id', e.target.value)} className="text-center" placeholder="자동" />
                      </td>
                      <td>
                        <Form.Control type="text" value={it.name} onChange={(e) => updateBnmRow('lc', idx, 'name', e.target.value)} className="text-center" />
                      </td>
                      <td>
                        <Form.Select value={it.protocol} onChange={(e) => updateBnmRow('lc', idx, 'protocol', e.target.value)}>
                          <option value="Bnm_lc">Bnm_lc</option>
                        </Form.Select>
                      </td>
                      <td className="text-center">
                        <Button size="sm" variant="outline-danger" onClick={() => removeBnmRow('lc', idx)}>X</Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                <div style={{ fontWeight: 600 }}>CO 추가 목록</div>
                <Button size="sm" variant="secondary" onClick={() => addBnmRow('co')}>행 추가</Button>
              </div>
              <Table striped bordered size="sm">
                <thead>
                  <tr>
                    <th>통신포트</th>
                    <th>IP</th>
                    <th>포트</th>
                    <th>장비ID</th>
                    <th>접속함 이름</th>
                    <th>프로토콜</th>
                    <th>삭제</th>
                  </tr>
                </thead>
                <tbody>
                  {bnmCoItems.map((it, idx) => (
                    <tr key={`co-${idx}`}>
                      <td>
                        <Form.Select value={it.commPort} onChange={(e) => updateBnmRow('co', idx, 'commPort', e.target.value)}>
                          {(settingList.commPortList || []).map((p) => (
                            <option key={p} value={p}>
                              {p}
                            </option>
                          ))}
                        </Form.Select>
                      </td>
                      <td>
                        {it.commPort === 'ETHERNET' && (
                          <Form.Control type="text" value={it.ip} onChange={(e) => updateBnmRow('co', idx, 'ip', e.target.value)} className="text-center" placeholder="192.168.x.x" />
                        )}
                      </td>
                      <td>
                        {it.commPort === 'ETHERNET' && (
                          <Form.Control type="text" value={it.port} onChange={(e) => updateBnmRow('co', idx, 'port', e.target.value)} className="text-center" placeholder="502" />
                        )}
                      </td>
                      <td>
                        <Form.Control type="text" value={it.id} onChange={(e) => updateBnmRow('co', idx, 'id', e.target.value)} className="text-center" placeholder="자동" />
                      </td>
                      <td>
                        <Form.Control type="text" value={it.name} onChange={(e) => updateBnmRow('co', idx, 'name', e.target.value)} className="text-center" />
                      </td>
                      <td>
                        <Form.Select value={it.protocol} onChange={(e) => updateBnmRow('co', idx, 'protocol', e.target.value)}>
                          <option value="Bnm_co">Bnm_co</option>
                        </Form.Select>
                      </td>
                      <td className="text-center">
                        <Button size="sm" variant="outline-danger" onClick={() => removeBnmRow('co', idx)}>X</Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowBnmAddModal(false)}>
            닫기
          </Button>
          <Button variant="primary" onClick={handleConfirmBnmAdd}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>






    </Container>
  );
}

export default JBSetting;
